export const noticeIconClass = 'w-12 h-12 text-[var(--color-ink-faint)]';
